module.exports = __webpack_public_path__ + "img/introTwo.85a5d293.png";